import { render, staticRenderFns } from "./PT055SoryoFreeLineParts.vue?vue&type=template&id=bdc0f88e&"
import script from "./PT055SoryoFreeLineParts.vue?vue&type=script&lang=js&"
export * from "./PT055SoryoFreeLineParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports